import { Rule } from '../rule'
import { uuid } from '../uuid'
import { ArrayDataOptions, DependOnOption, DisabledType } from '../common'

export class AutoCompleteDef {
  key?: string = uuid()
  type: 'autocomplete' = 'autocomplete'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: AutoCompleteOptions = new AutoCompleteOptions()
  rules?: Rule[]
}

export class AutoCompleteOptions {
  defaultValue?: string
  disabled?: DisabledType = false
  placeholder?: string
  maxlength?: number
  labelWidth?: string | number
  required?: boolean = false
  clearable?: boolean = true
  triggerOnFocus?: boolean = false
  remoteMethod?: (queryString: string, cb: (suggestions: ArrayDataOptions) => void, context?: any) => void
  onChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any> }) => void
  onSelect?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any> }) => void
  onBlur?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any> }) => void
  prefixIcon?: string
  suffixIcon?: string
  showWordLimit?: boolean = false
  labelDes?: string
  showLabel?: boolean = true
  valueKey?: string = 'value'
  attrs?: Record<string, any>
}

